import type {IStateMachine} from 'src/types/StateMachine';
import {useGetStateMachineQuery} from 'src/redux/queries/stateMachine';

export interface useStateMachineProps {
  url: string;
  skip?: boolean;
}
export function useStateMachine({
  url,
  skip,
}: useStateMachineProps): [IStateMachine | undefined, boolean] {
  const {data, isLoading} = useGetStateMachineQuery(url, {skip});
  return [data, isLoading];
}
